import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ProgressIndicator, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import * as actions from '../store/actions';
import EsriLoaderReact from 'esri-loader-react';
import Axios from 'axios';

class Mapp extends PureComponent {
  state = {
    loading: true,
    message: null,
    messageType: null,
    layerServices: [
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Locations.kmz', visible: false, chartable: false, popupEnabled: false},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Gages.kmz', visible: true, chartable: false, popupEnabled: false},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Bends.kmz', visible: true, chartable: false, popupEnabled: false},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Fort%20Peck%20Dam%20to%20Garrison%20Dam.kmz?attredirects=0&d=1', visible: true, chartable: true, popupEnabled: true},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Garrison%20Dam%20to%20Oahe%20Dam.kmz?attredirects=0&d=1', visible: true, chartable: true, popupEnabled: true},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Fort%20Randall%20Dam%20to%20Gavins%20Point%20Dam.kmz?attredirects=0&d=1', visible: true, chartable: true, popupEnabled: true},
      // {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Gavins%20Point%20Dam%20to%20Rulo.kmz?attredirects=0&d=1', visible: false, chartable: true, popupEnabled: true},
      // {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Rulo%20To%20Mouth.kmz?attredirects=0&d=1', visible: false, chartable: true, popupEnabled: true},
      {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Dams.kmz?attredirects=0&d=1', visible: true, chartable: false, popupEnabled: true},
      // {url: 'https://hydroviz.s3-us-west-2.amazonaws.com/Rivers.kmz?attredirects=0&d=1', visible: false, chartable: false, popupEnabled: true},
    ],
  };

  openChart = ({Reach, River, River_Stat, isFavorite}) => {
    Axios.get(`/api/query/findkeys/${River} ${Reach}/${River_Stat}`)
    .then(({data}) => {
      if(data.success){
        this.setState({
          redirect: {
            pathname: '/charts',
            state: {
              buildOnMount: true,
              method: 'Multiple Alternative',
              location: data.location_id, 
              river: data.river_id, 
              type: data.type_id, 
              source: data.source_id,
              isFavorite,
              axisText: `${data.type} (${data.units})`
            }
          }
        });
      } else {
        this.setState({message: 'Could not open a chart for this location', messageType: MessageBarType.warning }, () => this.clearMessage())
      };
    })
    .catch(err => {
      this.setState({message: 'Could not open this location', messageType: MessageBarType.error }, () => this.clearMessage())
    })
  }

  clearMessage = () => {
    setTimeout(() => this.setState({message: null, messageType: null}), 3000);
  };

  render() {
    const that = this;

    const options = {
      url: 'https://js.arcgis.com/4.8/'
    };

    if(that.state.redirect){
      return <Redirect
        to={ that.state.redirect }
      />
    };

    return (
      <div style={{width: '100%', height: '100%'}}>
        <EsriLoaderReact 
          options={ options }
          modulesToLoad={[
            "esri/Map",
            "esri/views/MapView",
            "esri/layers/KMLLayer",
            "esri/widgets/BasemapToggle",
            "esri/widgets/LayerList",
            "esri/core/watchUtils",
          ]}    
          onReady={({loadedModules: [Map, MapView, KMLLayer, BasemapToggle, LayerList, watchUtils ]}) => {

            function removeFavorite ({Reach, River, River_Stat}) {
              Axios.put('/api/query/favorites/remove', {river: `${River} ${Reach}`, location: River_Stat, user_id: that.props.user.id})
              .then(({data}) => {
                if(data.success){
                  view.popup.actions = view.popup.actions.map((action, index) => {
                    if(index === 0){
                      return {
                        id: 'add-favorite',
                        title: 'Add to Favorites',
                        type: 'button',
                        className: 'esri-icon-favorites',
                        visible: true
                      }
                    } else {
                      return action
                    }
                  });
                  that.setState({message: `Removed ${River_Stat} from favorites.`, messageType: MessageBarType.success}, () => {
                    that.clearMessage();
                    that.props.refreshFilters(that.props.user);
                  });
                } else {
                  that.setState({message: 'Unable to remove from favorites', messageType: MessageBarType.warning }, () => that.clearMessage());
                }
              })
              .catch(err => {
                that.setState({message: 'Unable to remove from favorites', messageType: MessageBarType.warning}, () => that.clearMessage());
              })
            };

            function addFavorite({ Reach, River, River_Stat }) {
              Axios.put('/api/query/favorites/add', {river: `${River} ${Reach}`, location: River_Stat, user_id: that.props.user.id})
              .then(({data}) => {
                if(data.success){
                  view.popup.actions = view.popup.actions.map((action, index) => {
                    if(index === 0){
                      return {
                        id: 'remove-favorite',
                        title: 'Remove from Favorites',
                        type: 'button',
                        className: 'esri-icon-error',
                        visible: true
                      }
                    } else {
                      return action
                    }
                  });
                  that.setState({message: `Added ${River} ${Reach} at ${River_Stat} to favorites.`, messageType: MessageBarType.success}, () => {
                    that.clearMessage();
                    that.props.refreshFilters(that.props.user);
                  });
                } else {
                  that.setState({message: 'Unable to add to favorites', messageType: MessageBarType.warning}, () => that.clearMessage());
                }
              })
              .catch(err => {
                that.setState({message: 'Unable to add to favorites', messageType: MessageBarType.warning}, () => that.clearMessage());
              })
            };

            async function checkFavoriteStatus(){
              const { attributes } = view.popup.features[0];
              if(attributes){
                const { Reach, River, River_Stat } = attributes
                return await Axios.get(`/api/query/favorites/check/${River} ${Reach}/${River_Stat}/${that.props.user.id}`);
              } else {
                return null
              }
            };

            let layers = this.state.layerServices.reverse().map(({url, visible, chartable, popupEnabled}) => {
              return new KMLLayer({ url, visible, chartable, popupEnabled, listMode: 'hide-children' });
            });

            let map = new Map({
              basemap: 'topo',
              layers
            });

            let view = new MapView({
              container: 'arc-map',
              map,
              center: [-100.4443, 44.2529],
              zoom: 6,
            });

            view.on("mouse-wheel", function(event) {
              // prevents zooming with the mouse-wheel event
              event.stopPropagation();
            });

            // add basemap toggle
            var basemapToggle = new BasemapToggle({
              view: view,  // The view that provides access to the map's "streets" basemap
              // nextBasemap: "satellite"  // Allows for toggling to the "hybrid" basemap
              nextBasemap: 'hybrid'
            });

            // add map gallery toggle to bottom-right
            view.ui.add(basemapToggle, {
              position: "bottom-right"
            });

            // create a layer list
            var layerList = new LayerList({
              view: view,
              listItemCreatedFunction: function (event) {
                // The event object contains properties of the
                // layer in the LayerList widget.
                var item = event.item;

                item.title = item.title.replace(/%20/g, " ");
              }
            });
            // Adds widget below other elements in the top left corner of the view
            view.ui.add(layerList, {
              position: "bottom-left"
            });

            watchUtils.watch(view.popup, 'features', function(){
              if(!view.popup.visible) return;
                view.popup.actions = []; // be deafult there shouldnt be any actions
              if(!view.popup.features[0].layer.chartable){
                view.popup.actions = []
              } else {
                // if its a chartable layer, check the status and conditionally add a button to the actions
                checkFavoriteStatus()
                .then(({data}) => {
                  if(data.success){
                    // if the river OR location are not favorites, show the button to add them
                    if(!data.river || !data.locaiton){
                      view.popup.actions = [
                        {
                          id: 'add-favorite',
                          title: 'Add to Favorites',
                          type: 'button',
                          className: 'esri-icon-favorites',
                          visible: true
                        },
                        {
                          id: 'open-chart',
                          title: 'Open in Chart',
                          type: 'button',
                          className: 'esri-icon-chart',
                          visible: true,
                          isFavorite: false
                        }
                      ]
                    }
                    if(data.location){
                      view.popup.actions = [
                        {
                          id: 'remove-favorite',
                          title: 'Remove from Favorites',
                          type: 'button',
                          className: 'esri-icon-error',
                          visible: true
                        },
                        {
                          id: 'open-chart',
                          title: 'Open in Chart',
                          type: 'button',
                          className: 'esri-icon-chart',
                          visible: true,
                          isFavorite: true
                        }
                      ]
                    }
                  } else {
                    // we dont have this location as a favorite, 
                    view.popup.actions = [
                      {
                        id: 'add-favorite',
                        title: 'Add to Favorites',
                        type: 'button',
                        className: 'esri-icon-favorites',
                        visible: true
                      },
                      {
                        id: 'open-chart',
                        title: 'Open in Chart',
                        type: 'button',
                        className: 'esri-icon-chart',
                        visible: true,
                        isFavorite: false
                      }
                    ]
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                })
              };
              const { location } = view.popup;
              if(location){
                const { latitude, longitude } = location;
                view.goTo({
                  center: [longitude, latitude]
                });
              };
            });

            // This event fires for each click on any action
            view.popup.on("trigger-action", function(event){
              // If the open-chart action is clicked, fire the openChart() function
              if(event.action.id === "add-favorite"){
                const { attributes } = view.popup.features[0];
                addFavorite({...attributes, popup: view.popup});
              };
              if(event.action.id === "remove-favorite"){
                const { attributes } = view.popup.features[0];
                removeFavorite({...attributes, popup: view.popup});
              };
              if(event.action.id === "open-chart"){
                const { attributes } = view.popup.features[0];
                that.openChart({...attributes, isFavorite: event.action.isFavorite});
              };
            });

            view.when(function(){
              // This function will execute once the promise is resolved
              that.setState({loading: false});
            }, function(error){
              // This function will execute if the promise is rejected due to an error
              that.setState({loading: false, error: 'Unable to generate map view.'});
            });
          }}
        />
        { that.state.loading && <ProgressIndicator />}
        { that.state.message && (
            <div className='alert-container'>
              <div className='message-wrapper'>
                <MessageBar className='alert-message' messageBarType={this.state.messageType || MessageBarType.success }>
                  { this.state.message }
                </MessageBar>
              </div>
            </div>
          )
        }
        <div id='arc-map' style={{height: '100%', outline: 'none'}}>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  user: state.auth.user
})

const mapDispatchToProps = dispatch => ({
  refreshFilters: (user) => dispatch(actions.getFilters(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(Mapp);



// WEBPACK FOOTER //
// ./src/containers/Map.js